import React, { useState, useEffect } from "react";
import WidgetPreview from "./WidgetPreview";
import { ChromePicker } from "react-color";
import { ClipboardIcon } from "@heroicons/react/20/solid";


function WidgetWA(c) {
  const channel = c["channel"];
  var col = "#000";
  var cName = "";
  var title = "";
  var subTitle = "";
  var welcome = "";
  switch (channel) {
    case "wa":
      col = "#25D366";
      cName = "WhatsApp";
      title = "Your WhatsApp Number";
      subTitle = "Include country code without + symbol.";
      welcome = 1;
      break;
    case "tg":
      col = "#2AABEE";
      cName = "Telegram";
      title = "Your Telegram Username";
      subTitle = "You should have received this name while creating your bot";
      welcome = 0;
      break;
    case "viber":
      col = "#8f5db7";
      cName = "Viber";
      title = "Your Viber URI";
      subTitle = "It can be found in the your bot's Admin Panel";
      welcome = 1;
      break;
    case "line":
      col = "#00B900";
      cName = "Line";
      title = "Your Line ID";
      subTitle =
        "You can find the LINE ID of your LINE Official Account, which starts with the @ symbol, in the header of LINE Official Account Manager";
      welcome = 0;
      break;
    default:
      break;
  }
  const [number, setNumber] = useState("");
  const [message, setMessage] = useState("");
  const [color, setColor] = useState(col);
  const [theme, setTheme] = useState("light");
  const [position, setPosition] = useState("right");
  const [shadow, setShadow] = useState("none");
  const [option, setOption] = useState(0);
  const [text, setText] = useState("Message Us");
  const [picker, setPicker] = useState(0);
  const [mb, setMb] = useState(20);
  const [mx, setMx] = useState(20);
  const [radius, setRadius] = useState(20);
  const [copyText, setCopyText] = useState("Copy to Clipboard");
  const code = (
    <div className="rounded-lg bg-gray-100 overflow-hidden p-4 my-4 text-sm text-gray-600">
      <div>✨ Minified Standalone {cName} Widget Script Generated - Copy using the button below</div>
    </div>
  );

  const [showCode, setShowCode] = useState(0);

  useEffect(() => {
    window.scroll({
      top: document.body.offsetHeight,
      left: 0, 
      behavior: 'smooth',
    })
  }, [showCode]);

  const onCopy = () => {
    const getIcon = (channel) => {
      switch(channel) {
        case 'wa':
          return '<svg width="20" height="20" viewBox="0 0 25 25" fill="currentColor"><path d="M18.1225 14.9458C17.8183 14.7895 16.3033 14.0473 16.0215 13.9469C15.7397 13.8409 15.5332 13.7907 15.3295 14.1032C15.123 14.4129 14.5371 15.102 14.3529 15.3113C14.1744 15.5178 13.993 15.5429 13.6889 15.3894C11.8808 14.4854 10.695 13.7767 9.50361 11.7315C9.18832 11.1874 9.8189 11.2265 10.4076 10.0518C10.5081 9.84534 10.4578 9.66956 10.3797 9.51331C10.3016 9.35706 9.68776 7.84478 9.43106 7.22815C9.18274 6.62826 8.92604 6.71197 8.7391 6.70081C8.56053 6.68965 8.35684 6.68965 8.15037 6.68965C7.9439 6.68965 7.61187 6.76777 7.33006 7.0719C7.04825 7.38161 6.25305 8.12659 6.25305 9.63887C6.25305 11.1511 7.35517 12.616 7.50584 12.8225C7.66209 13.0289 9.67381 16.1316 12.7625 17.4681C14.7157 18.3107 15.4802 18.3833 16.4567 18.2382C17.051 18.1489 18.2759 17.496 18.5298 16.7734C18.7837 16.0535 18.7837 15.4369 18.7084 15.3085C18.6331 15.1718 18.4266 15.0937 18.1225 14.9458Z" fill="currentColor"></path><path d="M24.0292 7.65625C23.3986 6.15792 22.4946 4.81306 21.3422 3.65792C20.198 2.50948 18.8395 1.5966 17.3439 0.970982C15.8093 0.326451 14.1798 0 12.5002 0H12.4444C10.7535 0.00837054 9.11567 0.343192 7.57549 1.00167C6.09267 1.63371 4.74699 2.54821 3.61344 3.6942C2.47226 4.84654 1.57661 6.18583 0.95719 7.67857C0.315449 9.22433 -0.00821224 10.8677 0.000158294 12.5586C0.00962607 14.4963 0.468048 16.4054 1.33944 18.1362V22.3772C1.33944 22.7176 1.47467 23.0441 1.71537 23.2848C1.95607 23.5255 2.28253 23.6607 2.62293 23.6607H6.86679C8.59752 24.5321 10.5067 24.9905 12.4444 25H12.5029C14.1743 25 15.7954 24.6763 17.3216 24.043C18.8097 23.4248 20.163 22.5226 21.306 21.3867C22.4583 20.2455 23.3651 18.9118 23.9985 17.4247C24.657 15.8845 24.9918 14.2467 25.0002 12.5558C25.0085 10.8566 24.6793 9.20759 24.0292 7.65625ZM19.8132 19.8772C17.8573 21.8136 15.2624 22.8795 12.5002 22.8795H12.4527C10.7702 22.8711 9.09893 22.4526 7.62293 21.6657L7.38855 21.5402H3.45998V17.6116L3.33442 17.3772C2.54759 15.9012 2.12906 14.2299 2.12069 12.5474C2.10953 9.76562 3.17259 7.15402 5.12293 5.18694C7.07047 3.21987 9.67371 2.1317 12.4555 2.12054H12.5029C13.898 2.12054 15.2513 2.39118 16.5264 2.9269C17.7708 3.44866 18.8869 4.19922 19.8467 5.15904C20.8037 6.11607 21.5571 7.23493 22.0788 8.47935C22.6201 9.76841 22.8908 11.1356 22.8852 12.5474C22.8685 15.3265 21.7775 17.9297 19.8132 19.8772Z" fill="currentColor"></path></svg>';
        case 'tg':
          return '<svg width="20" height="20" viewBox="0 0 25 25" fill="currentColor"><path d="M18.384,22.779c0.322,0.228 0.737,0.285 1.107,0.145c0.37,-0.141 0.642,-0.457 0.724,-0.84c0.869,-4.084 2.977,-14.421 3.768,-18.136c0.06,-0.28 -0.04,-0.571 -0.26,-0.758c-0.22,-0.187 -0.525,-0.241 -0.797,-0.14c-4.193,1.552 -17.106,6.397 -22.384,8.35c-0.335,0.124 -0.553,0.446 -0.542,0.799c0.012,0.354 0.25,0.661 0.593,0.764c2.367,0.708 5.474,1.693 5.474,1.693c0,0 1.452,4.385 2.209,6.615c0.095,0.28 0.314,0.5 0.603,0.576c0.288,0.075 0.596,-0.004 0.811,-0.207c1.216,-1.148 3.096,-2.923 3.096,-2.923c0,0 3.572,2.619 5.598,4.062Zm-11.01,-8.677l1.679,5.538l0.373,-3.507c0,0 6.487,-5.851 10.185,-9.186c0.108,-0.098 0.123,-0.262 0.033,-0.377c-0.089,-0.115 -0.253,-0.142 -0.376,-0.064c-4.286,2.737 -11.894,7.596 -11.894,7.596Z"/></svg>';
        case 'viber':
          return '<svg width="20" height="20" viewBox="0 0 25 25" fill="currentColor"><path d="M12.892 13.745s.427.038.656-.247l.448-.563c.216-.28.738-.458 1.249-.174.676.382 1.55.982 2.149 1.541.33.278.407.688.182 1.121l-.002.009c-.232.408-.541.791-.932 1.148l-.009.006c-.44.367-.946.58-1.487.404l-.01-.014c-.972-.275-3.304-1.464-4.79-2.649-2.431-1.918-4.159-5.082-4.637-6.778l-.015-.01c-.176-.543.039-1.049.404-1.488l.007-.008c.357-.391.739-.701 1.148-.932l.009-.002c.432-.225.842-.149 1.121.182.367.379 1.056 1.291 1.54 2.149.284.51.106 1.033-.173 1.248l-.564.448c-.284.23-.247.657-.247.657s.834 3.156 3.953 3.952zm4.907-2.616c-.167 0-.303-.135-.304-.302-.014-1.83-.564-3.288-1.634-4.332-1.072-1.045-2.427-1.581-4.027-1.592-.168-.001-.303-.138-.301-.306.001-.167.136-.301.303-.301h.002c1.762.012 3.258.606 4.447 1.764 1.19 1.162 1.802 2.765 1.817 4.763.001.167-.133.304-.301.306h-.002zm-1.595-.624h-.007c-.168-.004-.301-.143-.297-.31.024-1.038-.273-1.878-.906-2.569-.63-.689-1.495-1.065-2.645-1.149-.167-.013-.293-.158-.281-.325.013-.167.158-.293.325-.281 1.294.095 2.32.548 3.049 1.345.733.8 1.092 1.807 1.065 2.992-.004.165-.139.297-.303.297zm-1.558-.522c-.161 0-.295-.126-.303-.289-.051-1.03-.537-1.534-1.527-1.588-.168-.009-.296-.152-.287-.319.009-.168.151-.296.319-.287 1.308.07 2.034.819 2.101 2.164.009.167-.12.31-.288.318l-.015.001zm6.817 3.469c-.605 4.877-4.172 5.185-4.83 5.396-.28.09-2.882.737-6.152.524 0 0-2.438 2.94-3.199 3.705-.119.119-.258.167-.352.145-.131-.032-.167-.188-.165-.414l.02-4.016v-.001c-4.762-1.323-4.485-6.295-4.431-8.898.054-2.603.543-4.736 1.996-6.17 2.61-2.364 7.987-2.011 7.987-2.011 4.541.02 6.717 1.387 7.222 1.845 1.675 1.434 2.528 4.867 1.904 9.895zm-.652-11.113c-.597-.548-3.007-2.298-8.375-2.322 0 0-6.33-.382-9.416 2.45-1.718 1.718-2.322 4.231-2.386 7.348-.063 3.118-.146 8.958 5.484 10.542l.006.002-.004 2.416s-.035.979.609 1.179c.779.241 1.236-.502 1.981-1.304.408-.44.971-1.086 1.397-1.58 3.851.322 6.812-.417 7.149-.526.777-.253 5.177-.816 5.893-6.657.738-6.022-.358-9.83-2.338-11.548z"/></svg>';
        case 'line':
          return '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M24 10.304c0-5.369-5.383-9.738-12-9.738-6.616 0-12 4.369-12 9.738 0 4.814 4.269 8.846 10.036 9.608.391.084.922.258 1.057.592.121.303.079.778.039 1.085l-.171 1.027c-.053.303-.242 1.186 1.039.647 1.281-.54 6.911-4.069 9.428-6.967 1.739-1.907 2.572-3.843 2.572-5.992zm-18.988-2.595c.129 0 .234.105.234.234v4.153h2.287c.129 0 .233.104.233.233v.842c0 .129-.104.234-.233.234h-3.363c-.063 0-.119-.025-.161-.065l-.001-.001-.002-.002-.001-.001-.003-.003c-.04-.042-.065-.099-.065-.161v-5.229c0-.129.104-.234.233-.234h.842zm14.992 0c.129 0 .233.105.233.234v.842c0 .129-.104.234-.233.234h-2.287v.883h2.287c.129 0 .233.105.233.234v.842c0 .129-.104.234-.233.234h-2.287v.884h2.287c.129 0 .233.105.233.233v.842c0 .129-.104.234-.233.234h-3.363c-.063 0-.12-.025-.162-.065l-.003-.004-.003-.003c-.04-.042-.066-.099-.066-.161v-5.229c0-.062.025-.119.065-.161l.004-.004.003-.003c.042-.04.099-.066.162-.066h3.363zm-10.442.001c.129 0 .234.104.234.233v5.229c0 .128-.105.233-.234.233h-.842c-.129 0-.234-.105-.234-.233v-5.229c0-.129.105-.233.234-.233h.842zm2.127 0h.008l.012.001.013.001.01.001.013.003.008.003.014.004.008.003.013.006.007.003.013.007.007.004.012.009.006.004.013.011.004.004.014.014.002.002.018.023 2.396 3.236v-3.106c0-.129.105-.233.234-.233h.841c.13 0 .234.104.234.233v5.229c0 .128-.104.233-.234.233h-.841l-.06-.008-.004-.001-.015-.005-.007-.003-.012-.004-.011-.006-.007-.003-.014-.009-.002-.002-.06-.058-2.399-3.24v3.106c0 .128-.104.233-.234.233h-.841c-.129 0-.234-.105-.234-.233v-5.229c0-.129.105-.233.234-.233h.841z"/></svg>';
        default:
          return '<svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor"><path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/></svg>';
      }
    };

    // Generate the URL based on channel
    const generateUrl = () => {
      switch(channel) {
        case 'wa':
          return message ? `https://wa.me/${number}?text=${encodeURIComponent(message)}` : `https://wa.me/${number}`;
        case 'tg':
          return message ? `https://t.me/${number}?start=${encodeURIComponent(message)}` : `https://t.me/${number}`;
        case 'viber':
          return `viber://pa?chatURI=${number}&text=${encodeURIComponent(message || '')}`;
        case 'line':
          return `https://line.me/R/ti/p/${number}`;
        default:
          return '#';
      }
    };

    // Properly escape strings for JavaScript
    const escapeJs = (str) => {
      if (str === null || str === undefined) return '';
      const stringValue = String(str);
      return stringValue.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/"/g, '\\"').replace(/\n/g, '\\n').replace(/\r/g, '\\r');
    };

    const iconSvg = escapeJs(getIcon(channel));
    const targetUrl = generateUrl();

    const scriptContent = `<script>
(function(){
  if(window.ChatWidget_${channel}) return;
  
  var config = {
    number: "${escapeJs(number)}",
    message: "${escapeJs(message)}",
    color: "${escapeJs(color)}",
    channel: "${escapeJs(channel)}",
    boxShadow: "${escapeJs(shadow)}",
    text: "${escapeJs(text)}",
    theme: "${escapeJs(theme)}",
    position: "${escapeJs(position)}",
    mb: "${escapeJs(mb)}px",
    mx: "${escapeJs(mx)}px",
    radius: "${escapeJs(radius)}px"
  };
  
  function createWidget() {
    var widget = document.createElement('div');
    widget.id = 'chat-widget-${escapeJs(channel)}';
    widget.style.cssText = 'position:fixed;' + config.position + ':' + config.mx + ';bottom:' + config.mb + ';z-index:999999;cursor:pointer';
    
    var shadowCss = config.boxShadow === 'none' ? '' : 
      config.boxShadow === 'low' ? 'box-shadow:0 1px 3px rgba(0,0,0,0.12);' :
      config.boxShadow === 'medium' ? 'box-shadow:0 4px 6px rgba(0,0,0,0.15);' :
      'box-shadow:0 10px 25px rgba(0,0,0,0.2);';
    
    var textColor = config.theme === 'dark' ? '#000000' : '#ffffff';
    
    widget.innerHTML = '<div style="background-color:' + config.color + ';color:' + textColor + ';padding:12px 20px;border-radius:' + config.radius + ';display:flex;align-items:center;gap:8px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,sans-serif;font-size:14px;font-weight:500;text-decoration:none;transition:all 0.3s ease;' + shadowCss + '" onmouseover="this.style.transform=\\'scale(1.05)\\'" onmouseout="this.style.transform=\\'scale(1)\\';">${iconSvg}' + config.text + '</div>';
    
    widget.onclick = function() {
      window.open('${escapeJs(targetUrl)}', '_blank');
    };
    
    document.body.appendChild(widget);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createWidget);
  } else {
    createWidget();
  }
  
  window.ChatWidget_${channel} = true;
})();
</script>`;
    navigator.clipboard.writeText(scriptContent);
    setCopyText("Copied!");
  };

  const cleanData = (x) => {
    switch (channel) {
      case 'wa':
        return x.replace(/[^0-9]/g, "");
      case 'tg':
        return x.replace("@", "");
      case 'line':
        return x.replace("@", "");
      case 'viber':
        return x;
      default:
        return x;
    }
  }

  return (
    <div className="px-8 md:px-24 mt-8">
      <div className="text-xl my-4">Your Chat Widget Preview</div>

      <WidgetPreview
        number={number}
        text={text}
        color={color}
        theme={theme}
        radius={radius + "px"}
        boxShadow={shadow}
        channel={channel}
      />
      <div className="text-xl my-8">Customise your Chat Widget</div>
      <div className="min-h-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <div className={welcome ? "" : "col-span-2"}>
          <label
            htmlFor="phone"
            className="block text-sm font-medium text-gray-700"
          >
            {title}
          </label>

          <div className="mt-1">
            <input
              name="phone"
              autoFocus
              type="text"
              value={number}
              onChange={(e) => setNumber(cleanData(e.target.value))}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>
          <p className="mt-2 text-sm text-gray-500">{subTitle}</p>
        </div>

        {welcome ? (
          <div>
            <label
              htmlFor="message"
              className="block text-sm font-medium text-gray-700"
            >
              Welcome Message (Optional)
            </label>

            <div className="mt-1">
              <input
                name="message"
                type="text"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
              />
            </div>
            <p className="mt-2 text-sm text-gray-500">
              Automatically include this text when a user clicks on your chat
              link.
            </p>
          </div>
        ) : (
          <></>
        )}
        <div>
          <label
            htmlFor="cta"
            className="block text-sm font-medium text-gray-700"
          >
            CTA Text
          </label>

          <div className="mt-1">
            <input
              name="cta"
              type="text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
          </div>
        </div>
        <div className="relative">
          <label
            htmlFor="search"
            className="block text-sm font-medium text-gray-700"
          >
            Button Color
          </label>
          <div className="mt-1 relative">
            <input
              name="search"
              type="text"
              value={color}
              onChange={(e) => setColor(e.target.value)}
              className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
            />
            <div className="absolute inset-y-0 right-0 flex py-1.5 pr-1.5">
              <span
                className="cursor-pointer inline-flex items-center rounded px-4"
                style={{
                  background: color,
                }}
                onClick={() => setPicker(!picker)}
              />
            </div>
          </div>
          {picker ? (
            <div className="absolute z-50 right">
              <ChromePicker
                color={color}
                onChangeComplete={(e) => setColor(e.hex)}
              />
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      <div className="relative my-8">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex items-center justify-between">
          <span className="pr-3 bg-white text-lg">Advanced Options</span>
          <button
            type="button"
            className="inline-flex items-center shadow-sm px-4 py-1.5 border border-gray-300 text-sm leading-5 font-medium rounded-full text-gray-700 bg-white hover:bg-gray-50"
            onClick={() => setOption(!option)}
          >
            <span>{option ? "Hide" : "Show"}</span>
          </button>
        </div>
      </div>
      {option ? (
        <div className="min-h-full grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          <div>
            <label
              htmlFor="theme"
              className="block text-sm font-medium text-gray-700"
            >
              Text & Icon Theme
            </label>
            <select
              name="theme"
              defaultValue={theme}
              onChange={(e) => setTheme(e.target.value)}
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
            </select>
          </div>
          <div>
            <label
              htmlFor="position"
              className="block text-sm font-medium text-gray-700"
            >
              Widget Position
            </label>
            <select
              name="position"
              defaultValue={position}
              onChange={(e) => setPosition(e.target.value)}
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
            >
              <option value="right">Right Side</option>
              <option value="left">Left Side</option>
            </select>
          </div>
          <div>
            <label
              htmlFor="mb"
              className="block text-sm font-medium text-gray-700"
            >
              Margin Bottom
            </label>
            <div className="flex mt-1">
              <div>
                <input
                  name="mb"
                  type="number"
                  onChange={(e) => setMb(e.target.value)}
                  value={mb}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-none rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
              </div>
              <div className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50">
                <span>px</span>
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="mx"
              className="block text-sm font-medium text-gray-700"
            >
              Margin {position.charAt(0).toUpperCase() + position.slice(1)}
            </label>
            <div className="flex mt-1">
              <div>
                <input
                  name="mx"
                  type="number"
                  onChange={(e) => setMx(e.target.value)}
                  value={mx}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-none rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
              </div>
              <div className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50">
                <span>px</span>
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="radius"
              className="block text-sm font-medium text-gray-700"
            >
              Corner Radius
            </label>
            <div className="flex mt-1">
              <div>
                <input
                  name="radius"
                  type="number"
                  onChange={(e) => setRadius(e.target.value)}
                  value={radius}
                  className="block w-full px-3 py-2 border border-gray-300 rounded-none rounded-l-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
              </div>
              <div className="-ml-px relative inline-flex items-center space-x-2 px-4 py-2 border border-gray-300 text-sm font-medium rounded-r-md text-gray-700 bg-gray-50">
                <span>px</span>
              </div>
            </div>
          </div>

          <div>
            <label
              htmlFor="shadow"
              className="block text-sm font-medium text-gray-700"
            >
              Box Shadow
            </label>
            <select
              name="shadow"
              defaultValue={shadow}
              onChange={(e) => setShadow(e.target.value)}
              className="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-md"
            >
              <option value="none">None</option>
              <option value="low">Low</option>
              <option value="medium">Medium</option>
              <option value="high">High</option>
            </select>
          </div>
        </div>
      ) : (
        <></>
      )}

      <div className="text-xl mt-8 mb-3">Generate {cName} Button Code</div>
      <p className="mt-2 text-sm text-gray-500">
        You can use the code in your website to get a {cName} Button for Free
      </p>
      <button
        onClick={() => {
          setShowCode(1);
        }}
        className="flex justify-center mt-6 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary-dark"
      >
        Generate {cName} Button Code
      </button>
      {showCode ? (
        <div className="mt-3">
          <p>
            Copy this code and paste before the &lt;/body&gt; tag on every page
            of your website.
          </p>
          <div className="relative">
            <div className="absolute right-0">
              <button
                type="button"
                onClick={() => onCopy()}
                className="inline-flex items-center px-3 py-2 text-sm leading-4 font-medium rounded-tr-md text-white bg-primary hover:bg-primary-dark"
              >
                <ClipboardIcon
                  className="-ml-1 mr-2 h-5 w-5"
                  aria-hidden="true"
                />
                {copyText}
              </button>
            </div>
            
              {code}
            
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default WidgetWA;
